import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { mergeMap, switchMap } from 'rxjs/operators';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { RuleTranslator } from '@cbridge-packages/rule';
import { PricingRuleTranslator } from '../pricingRule.translator';
import { PricingRuleAction } from '../pricingRule.action';

type IDependencies = IClientApiDependencySegment;

export const validatePricingRuleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PricingRuleAction.validate.started),
  switchMap((params) => {
    const rules = params.map(PricingRuleTranslator.toApi);
    return dependencies.api.validatePricingRules({ rules }).pipe(
      mergeMap((response) => {
        return [
          PricingRuleAction.validate.done({ params, result: (response.rules ?? []).map(RuleTranslator.fromApiValidation) }),
        ];
      }),
      catchApiError((error) => {
        return [
          PricingRuleAction.validate.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
